import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // The backend redirects here as /dashboard#token=<jwt> after Google sign-in.
    const token = location.hash?.split("token=")[1];
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    const finishSignIn = async () => {
      try {
        const res = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });
        login(res.data, token);
        // Strip the token out of the URL so it does not sit in browser history.
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (err) {
        console.error("Auth callback error:", err);
        navigate("/login", { replace: true });
      }
    };

    finishSignIn();
  }, [location.hash, navigate, login]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-muted-foreground font-body">Signing you in...</p>
      </div>
    </div>
  );
}
